import { setupWorker } from 'msw/browser';

import { passthroughNonApiHandler } from './passthrough-non-api.handler';

export const worker = setupWorker(passthroughNonApiHandler);

export { startDevMswWorker } from './start-worker';
